import React, { useMemo } from 'react';
import {
  Configuration,
  NewsletterApi,
  ProfileApi,
  SubscriptionApi,
  CancellationApi,
} from '@ktag/newsletters-sdk';
import { agwputil } from '@ktag/styleguide/dist/platform';
import { NewsletterConfig } from 'types/config.types';

export type AppMode = 'list' | 'actions' | 'latest' | 'viewer' | 'manage';
export type ActionsOrigin = 'overview' | 'detail';

const MOCK_CONFIG = {
  defaultFields: [
    {
      name: 'email',
      label: 'E-Mail-Adresse',
      required: true,
      type: 'string',
      multiline: false,
    },
    {
      name: 'salutation',
      label: 'Anrede',
      required: false,
      type: 'select',
      options: [
        {
          value: 'Herr',
          label: 'Herr',
        },
        {
          value: 'Frau',
          label: 'Frau',
        },
        {
          value: 'Divers',
          label: 'Divers',
        },
        {
          value: 'Keine Angabe',
          label: 'Keine Angabe',
        },
      ],
    },
    {
      name: 'lastname',
      label: 'Nachname',
      required: false,
      type: 'string',
      multiline: false,
    },
    {
      name: 'firstname',
      label: 'Vorname',
      required: false,
      type: 'string',
      multiline: false,
    },
  ],
  lists: [
    {
      id: 3034,
      title: 'Energieberatung Aargau',
      description:
        'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
      fields: [
        {
          name: 'institution',
          label: 'Institution',
          required: true,
          type: 'select',
          options: [
            {
              value: 'corporation',
              label: 'Unternehmen',
            },
            {
              value: 'individual',
              label: 'Privatperson',
            },
          ],
        },
      ],
    },
    {
      id: 3035,
      title: 'Smart Aargau',
      description:
        'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
      fields: [
        {
          name: 'institution',
          label: 'Institution',
          required: true,
          type: 'select',
          options: [
            {
              value: 'corporation',
              label: 'Unternehmen',
            },
            {
              value: 'individual',
              label: 'Privatperson',
            },
          ],
        },
      ],
    },
    {
      id: 3036,
      title: 'Gesundheit',
      description:
        'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
    },
    {
      id: 3037,
      title: 'Handbuch Soziales',
      description:
        'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
    },
    {
      id: 3038,
      title: 'Kantonale Denkmalpflege',
      description:
        'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
    },
    {
      id: 414,
      title: 'Testliste1 - NICHT LÖSCHEN',
      description:
        'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
      fields: [
        {
          name: 'bksakZielgruppe',
          label: 'Zielgruppe',
          required: false,
          type: 'select',
          options: [
            {
              value: 'Lehrperson',
              label: 'Lehrperson',
            },
            {
              value: 'Kulturinstitution',
              label: 'Kulturinstitution',
            },
            {
              value: 'Kulturschaffende',
              label: 'Kulturschaffende',
            },
            {
              value: 'Bibliothek',
              label: 'Bibliothek',
            },
          ],
        },
        {
          name: 'bksakTheaterfunken',
          label: 'Newsletter Theaterfunken',
          required: false,
          type: 'checkbox',
          toggleLabel: 'Ich bin interessiert',
        },
        {
          name: 'testRadio',
          label: 'Test Radio',
          required: false,
          type: 'radio',
          options: [
            {
              value: 'Test Radio 1',
              label: 'Test Radio 1',
            },
            {
              value: 'Test Radio 2',
              label: 'Test Radio 2',
            },
          ],
        },
      ],
    },
    {
      id: 415,
      title: 'Kultur macht Schule',
      description:
        'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
      fields: [
        {
          name: 'bksakZielgruppe',
          label: 'Zielgruppe',
          required: false,
          type: 'select',
          options: [
            {
              value: 'Lehrperson',
              label: 'Lehrperson',
            },
            {
              value: 'Kulturinstitution',
              label: 'Kulturinstitution',
            },
            {
              value: 'Kulturschaffende',
              label: 'Kulturschaffende',
            },
            {
              value: 'Bibliothek',
              label: 'Bibliothek',
            },
          ],
        },
        {
          name: 'bksakTheaterfunken',
          label: 'Newsletter Theaterfunken',
          required: false,
          type: 'checkbox',
          toggleLabel: 'Ich bin interessiert',
        },
        {
          name: 'testMultiline',
          label: 'Test Multiline',
          required: false,
          type: 'string',
          multiline: true,
        },
        {
          name: 'testRadio',
          label: 'Test Radio',
          required: false,
          type: 'radio',
          options: [
            {
              value: 'Test Radio 1',
              label: 'Test Radio 1',
            },
            {
              value: 'Test Radio 2',
              label: 'Test Radio 2',
            },
          ],
        },
      ],
    },
  ],
};

const AppContext = React.createContext<{
  baseApiUrl: string;
  mocked: boolean;
  mode: AppMode;
  config: NewsletterConfig;
  newsletterApi: NewsletterApi;
  profileApi: ProfileApi;
  subscriptionApi: SubscriptionApi;
  cancellationApi: CancellationApi;
  manageBaseUrl: string;
  overviewBaseUrl: string;
  viewerBaseUrl: string;
  latestId: number;
  latestCount: number;
  actionsShowSubscribe: boolean;
  actionsShowEdit: boolean;
  actionsShowUnsubscribe: boolean;
  actionsId: number;
  actionsOrigin: ActionsOrigin;
  siteKey: string;
}>({
  baseApiUrl: '',
  mocked: false,
  mode: 'list',
  config: null,
  newsletterApi: null,
  profileApi: null,
  subscriptionApi: null,
  cancellationApi: null,
  manageBaseUrl: '',
  overviewBaseUrl: '',
  viewerBaseUrl: '',
  latestId: null,
  latestCount: null,
  actionsShowSubscribe: null,
  actionsShowEdit: null,
  actionsShowUnsubscribe: null,
  actionsId: null,
  actionsOrigin: null,
  siteKey: null,
});

export default AppContext;

interface Props {
  children: React.ReactNode;
  baseApiUrl: string;
  mocked?: boolean;
  mode?: AppMode;
  config: NewsletterConfig;
  manageBaseUrl: string;
  overviewBaseUrl: string;
  viewerBaseUrl: string;
  latestId: number;
  latestCount: number;
  actionsShowSubscribe: boolean;
  actionsShowEdit: boolean;
  actionsShowUnsubscribe: boolean;
  actionsId: number;
  actionsOrigin: ActionsOrigin;
  siteKey: string;
}

export const AppContextProvider = ({
  children,
  baseApiUrl,
  mocked,
  mode = 'list',
  config,
  manageBaseUrl,
  overviewBaseUrl,
  viewerBaseUrl,
  latestId,
  latestCount,
  actionsShowSubscribe,
  actionsShowEdit,
  actionsShowUnsubscribe,
  actionsId,
  actionsOrigin,
  siteKey,
}: Props) => {
  const apiConfig = new Configuration({
    basePath: baseApiUrl,
    fetchApi: agwputil.authenticatedFetch,
  });

  const newsletterApi = new NewsletterApi(apiConfig);
  const profileApi = new ProfileApi(apiConfig);
  const subscriptionApi = new SubscriptionApi(apiConfig);
  const cancellationApi = new CancellationApi(apiConfig);

  const secureConfig = config || MOCK_CONFIG;

  const value = useMemo(
    () => ({
      baseApiUrl,
      mocked,
      mode,
      config: secureConfig,
      newsletterApi,
      profileApi,
      subscriptionApi,
      cancellationApi,
      manageBaseUrl,
      overviewBaseUrl,
      viewerBaseUrl,
      latestId,
      latestCount,
      actionsShowSubscribe,
      actionsShowEdit,
      actionsShowUnsubscribe,
      actionsId,
      actionsOrigin,
      siteKey,
    }),
    [
      baseApiUrl,
      mocked,
      mode,
      secureConfig,
      newsletterApi,
      profileApi,
      subscriptionApi,
      cancellationApi,
      manageBaseUrl,
      overviewBaseUrl,
      viewerBaseUrl,
      latestId,
      latestCount,
      actionsShowSubscribe,
      actionsShowEdit,
      actionsShowUnsubscribe,
      actionsId,
      actionsOrigin,
      siteKey,
    ],
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
